import { render, staticRenderFns } from "./seasonalProduct.vue?vue&type=template&id=2c7c7e80&scoped=true"
import script from "./seasonalProduct.vue?vue&type=script&lang=ts"
export * from "./seasonalProduct.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7c7e80",
  null
  
)

export default component.exports